/*
 * Controls the main interactions on the U1 template. This module
 * is focused on navigation to the 'content' section, which is the
 * scrollable section displayed after the hero image section and the
 * transperant section that reveals the position:fixed video underneath
 *
 * @author BarrelNY
 *
 */

var Interactions = {
	init:function(){
		//What templates should trigger this module?
		var templates = [
			'body.U1-template',
			'body.U1-template-test'
		].join();

		if (!$(templates).length) return;

		this.$inner = $('.inner-content');
		this.$outer = $('.scroll');

		this.events();
		this.setAnimations();
	},

	events:function(){
		$('body')
			.on('fullPage__afterLoad',this.toggleWheelEvents.bind(this))
			.on('fullPage__onLeave',this.viewContent.bind(this));

		//By having an event handler attached to the doc
		//(even an empty anon function), the default scroll
		//behaviour still triggers after 'setMouseWheelScrolling'
		//removes the plugin's handler.. stops all scroll behavior
		//until a window event triggers if we don't have this..
		$(document).on('mousewheel wheel',function(){});
	},

	setAnimations:function(){
		this.animations = {};

		this.animations.expose =
			new TimelineMax()
			.fromTo(this.$inner,3,{scale:0.90},{scale:1})
			.pause();

	},

	/*
	 * In order for the content section to be scrollable, we need
	 * to disable the mousewheel events that control the fullpage
	 * plugin, as the user's scroll up will trigger movement to
	 * the video or hero image section, making the content section
	 * unusable. We also change the header so it doesn't sit above
	 * the content section's scrollbar
	 *
	 * @param	obj	event object
	 * @param	string	anchor link corresponding to the section
	 * @param	string	current section index
	 * @returns void
	 */
	toggleWheelEvents:function(e,anchorLink,index){
		if ( this.isContentSection(index) ){
			$('body').trigger('fullPage__disableInteractions');

			//Avoids the menu sitting over the scroll bar
			this.repositionMenu(true);
		} else {
			//reverse the action
			this.repositionMenu();
		}
	},

	/*
	 * Determine if the next section coming into view
	 * is the content section. Inherits params
	 * from plugin "onLeave" callback
	 *
	 * @param	obj	event object
	 * @param	string	index we're moving away from
	 * @param	string	index we're moving towards
	 * @param	string	the direction we are going
	 * @returns void
	 */
	viewContent:function(e,index, nextIndex, direction){
		if (MUR.anchorTriggered){
			MUR.anchorTriggered = false;
			var skipAnimation = true;
		}

		//Moving towards le content
		if ( this.isContentSection(nextIndex) ){
			var delay = (MUR.animation.duration/4)*2;

			if (!skipAnimation){
				setTimeout(this.exposeContent.bind(this),delay);
			} else {
				TweenMax.set(this.$inner,{scale:1});
			}

		//Moving away from le content
		} else if ( this.isContentSection(index) ){
			this.revertExposeContent();
		}
	},

	/*
	 * Play the content section's 'reveal' animation:
	 * scale and opacity fade into view
	 *
	 * @params	void
	 * @returns	void
	 */
	exposeContent:function(){
		this.animations.expose.play(0);
	},

	/*
	 * Revert the animation, used when we navigate away
	 * from the content section
	 *
	 * @params	void
	 * @returns	void
	 */
	revertExposeContent:function(){
		this.animations.expose.reverse(0);
	},

	/*
	 * Change the padding-right	 of the header's containing
	 * element so that it doesn't sit on top of the nested
	 * scroll bar of the content section
	 *
	 * @params	bool	whether we are placing or removing
	 * @returns	void
	 */
	repositionMenu:function(instate){
		//Reposition
		if (instate){
			var padding = $(window).width() - this.$inner.width();
			$('.header-wrapper').css({paddingRight:padding});
		} else {
			$('.header-wrapper').css({paddingRight:0});
		}
	},

	/*
	 * Is this the content section?
	 *
	 * @param	string	index to assess
	 * @returns	bool	is this the content section
	 */
	isContentSection:function(index){
		//Added to conteract afterLoad event
		//triggered after rendered AJAX response
		var isContentSection = !!$('.section-3.content.active').length;
		if (!isContentSection) return false;

		if (
			(index == 3) ||
			(Modernizr.touch && index == 2)
		) return true;
		return false;
	},

	/*
	 * Prep for re-init
	 * @param	void
	 * @returns void
	 */
	drop:function(){
		$('body')
			.off('fullPage__afterLoad',this.toggleWheelEvents)
			.off('fullPage__onLeave',this.viewContent);
	}
}

module.exports = Interactions;
